//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {

    }
  },

  props: {
    collection: {
      type: Object,
      default: null
    }
  },

  methods: {
    goToCollection () {
      this.$router.push({
        name: 'collection',
        params: {
          id: this.collection.id
        }
      })
    }
  }
}  



// WEBPACK FOOTER //
// ./src/components/ClassicItem.vue